import { render, staticRenderFns } from "./SuperTouchPcZh.vue?vue&type=template&id=87dc92dc&scoped=true&"
import script from "./SuperTouchPcZh.vue?vue&type=script&lang=js&"
export * from "./SuperTouchPcZh.vue?vue&type=script&lang=js&"
import style0 from "./SuperTouchPcZh.vue?vue&type=style&index=0&id=87dc92dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dc92dc",
  null
  
)

export default component.exports